import React, { useEffect } from "react";
import { Image } from "antd";
import { Dialog, DialogContent } from "@material-ui/core";
import styles from "./index.module.less";

const MediaShow = ({ type, src, open, onClose }) => {
  return (
    <>
      {type==="image" && (
        <Image
          style={{display: "none"}}
          preview={{
            visible: open,
            src,
            onVisibleChange: (value) => {
              onClose()
            },
            rootClassName: styles.imagePreviewRoot
          }}
        />
      )}
      {type === "video" && (
        <Dialog
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="100vw"
          sx={{ padding: 0 }}
          PaperProps={{
            style: {
              padding: 0,
              margin: 0,
              width: "fit-content",
              height: "fit-content"
            }
          }}
        >
          <DialogContent
            className={styles.videoPlayerWrapper}
          >
            <div>
              <video
                src={src}
                controls
                autoPlay
                style={{
                  display: 'block',
                  maxWidth: '70vw',
                  maxHeight: "70vh",
                }}
              />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default MediaShow